import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';

export default function BusyOverlay({
    show,
    children,
    minHeight = 0,
    spinnerSize = 32,
}) {
    return (
        <Box
            position="relative"
            minHeight={minHeight}
            height="100%"
            display="flex"
            flexDirection="column"
            aria-busy={show}
            sx={{ isolation: 'isolate' }}
        >
            <Box
                sx={{
                    filter: show ? 'blur(2px)' : 'none',
                    transition: 'filter 160ms ease',
                    pointerEvents: show ? 'none' : 'auto',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {children}
            </Box>
            {show && (
                <Box
                    position="absolute"
                    top={0}
                    right={0}
                    bottom={0}
                    left={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    role="status"
                    aria-label="Refreshing content"
                    sx={{
                        zIndex: 1,
                        pointerEvents: 'none',
                        borderRadius: 1,
                    }}
                >
                    <CircularProgress color="primary" size={spinnerSize} />
                </Box>
            )}
        </Box>
    );
}

BusyOverlay.propTypes = {
    show: PropTypes.bool,
    children: PropTypes.node,
    minHeight: PropTypes.number,
    spinnerSize: PropTypes.number,
};
